import { Outlet, Link } from 'react-router-dom';

export function AuthLayout() {
    return (
        <div className="min-h-screen flex">
            {/* Left panel - Elegant Branding */}
            <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary-600 via-primary-700 to-accent-600 p-12 flex-col justify-between relative overflow-hidden">
                {/* Subtle pattern overlay */}
                <div className="absolute inset-0 opacity-10">
                    <div className="absolute top-20 right-20 w-64 h-64 bg-white rounded-full blur-3xl"></div>
                    <div className="absolute bottom-40 left-10 w-48 h-48 bg-white rounded-full blur-3xl"></div>
                </div>

                <div className="relative z-10">
                    <Link to="/" className="inline-flex items-center gap-3">
                        <img src="/gofit-logo.png" alt="GoFit" className="w-12 h-12" />
                        <span className="font-bold text-2xl text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                            GoFit
                        </span>
                    </Link>
                </div>

                <div className="max-w-md relative z-10">
                    <h1 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                        Gerencie seus alunos com elegância
                    </h1>
                    <p className="text-lg text-primary-100 leading-relaxed">
                        Treinos personalizados, cobranças automáticas e evolução em tempo real.
                        Tudo em uma plataforma simples e poderosa.
                    </p>
                </div>

                <div className="flex items-center gap-10 relative z-10">
                    <div>
                        <p className="text-2xl font-bold text-white">500+</p>
                        <p className="text-sm text-primary-200">Personal Trainers</p>
                    </div>
                    <div>
                        <p className="text-2xl font-bold text-white">10k+</p>
                        <p className="text-sm text-primary-200">Alunos Ativos</p>
                    </div>
                    <div>
                        <p className="text-2xl font-bold text-white">98%</p>
                        <p className="text-sm text-primary-200">Satisfação</p>
                    </div>
                </div>
            </div>

            {/* Right panel - Auth form */}
            <div className="flex-1 flex items-center justify-center p-6 bg-white dark:bg-gray-950">
                <div className="w-full max-w-md">
                    {/* Mobile logo */}
                    <div className="lg:hidden mb-8 text-center">
                        <Link to="/" className="inline-flex items-center gap-2">
                            <img src="/gofit-logo.png" alt="GoFit" className="w-10 h-10" />
                            <span className="font-bold text-xl text-gray-900 dark:text-white" style={{ fontFamily: 'Outfit, sans-serif' }}>
                                GoFit
                            </span>
                        </Link>
                    </div>

                    <Outlet />
                </div>
            </div>
        </div>
    );
}
